/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'ai-mate.all-chat-view.chat-item.chat-options-button-label': 'Možnosti chatu pro: {conversationName}',
  'ai-mate.all-chat-view.chat-item.delete-label': 'Odstranit',
  'ai-mate.all-chat-view.chat-item.rename-label': 'Přejmenovat',
  'ai-mate.all-chat-view.new-chat-button-label': 'Nový chat',
  'ai-mate.chat-error-banner.description': 'Vaše historie chatu je uložena na 30 dní.',
  'ai-mate.chat-error-banner.title': 'Zahájit nový chat',
  'ai-mate.chat-error.description': 'Zkuste <btn>znovu načíst chat</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Dosáhli jste maximálního počtu žádostí. Zkuste to znovu později.',
  'ai-mate.chat-error.rate-limited-title': 'Příliš mnoho žádostí',
  'ai-mate.chat-error.rovo-inactive-description':
    'Zdá se, že nástroj Rovo není na vašem webu zapnutý. <link>Nastavení nástroje Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Nástroj Rovo není aktivní',
  'ai-mate.chat-error.title': 'Nejsme si jistí, kde se stala chyba',
  'ai-mate.chat-history.loading-state.collapse-icon': 'Sbalit',
  'ai-mate.chat-history.loading-state.expand-icon': 'Rozbalit',
  'ai-mate.chat-history.loading-state.rovo-is-thinking': 'Rovo přemýšlí',
  'ai-mate.chat-input.file-close-icon-label': 'Odebrat soubor',
  'ai-mate.chat-input.file-error-icon-label': 'Chyba při načítání souboru',
  'ai-mate.chat-input.store-user-messages.label': 'Nahrát tuto zprávu, abyste nám pomohli zlepšit kvalitu odpovědí',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Odstranit',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': 'Možnosti chatu pro: {conversationName}',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Přejmenovat',
  'ai-mate.common.ui.expandable-section.collapse': 'Sbalit',
  'ai-mate.common.ui.expandable-section.expand': 'Rozbalit',
  'ai-mate.conversation-assistant-page-selector.page-selector-label': 'Vyberte stránku',
  'ai-mate.conversation-assistant-space-selector.space-selector-label': 'Vyberte prostor',
  'ai-mate.conversation-assistant-space-selector.suggested-spaces-heading': 'Navrhované prostory',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Zrušit',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'Konverzace, kterou se pokoušíte odstranit, neexistuje.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Odstranit',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Odstranit konverzaci „{name}“?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Při odstraňování konverzace došlo k chybě. Zkuste to znovu.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Opravdu chcete tuto odstranit tuto konverzaci? Akci nejde vrátit zpět.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Zrušit',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'Kanál, který se pokoušíte upravit, neexistuje.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Název',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Při úpravě konverzace došlo k chybě. Zkuste to znovu.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Upravit konverzaci',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'Název je stejný jako aktuální název.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Uložit',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, one {{results,number} nalezený výsledek} few {{results,number} nalezené výsledky} many {{results,number} nalezeného výsledku} other {{results,number} nalezených výsledků}}',
  'ai-mate.conversation-list-view.back-button.label': 'Zpět',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Zavřít chat',
  'ai-mate.conversation-list-view.header-title': 'Historie chatu',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Nový chat',
  'ai-mate.conversation-list-view.no-chat': 'Žádné výsledky',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Vyhledat chaty',
  'ai-mate.date-time-utils.time.now': 'Právě teď',
  'ai-mate.date-time-utils.time.yesterday': 'Včera',
  'ai-mate.expander.hide-details': 'Skrýt podrobnosti',
  'ai-mate.expander.show-details': 'Zobrazit více podrobností',
  'ai-mate.loading-status-indicator.discovery': 'Objevování',
  'ai-mate.loading-status-indicator.error': 'Chyba',
  'ai-mate.loading-status-indicator.info': 'Informace',
  'ai-mate.loading-status-indicator.loading': 'Načítání',
  'ai-mate.loading-status-indicator.success': 'Úspěch',
  'ai-mate.loading-status-indicator.todo': 'K provedení',
  'ai-mate.loading-status-indicator.warning': 'Varování',
  'ai-mate.main-chat.close-chat-panel-button-label': 'Zavřít chat',
  'ai-mate.main-chat.hamburger-menu-label': 'Nabídka',
  'ai-mate.main-chat.maximize-chat-button-label': 'Celá obrazovka',
  'ai-mate.main-chat.minimize-chat-button-label': 'Obnovit zobrazení',
  'ai-mate.main-chat.new-chat-button-label': 'Nové',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nový chat',
  'ai-mate.rovo-chat-header.back-home-button-label': 'Přejít zpět domů',
  'ai-mate.rovo-chat-header.chrome-extension-button-text': 'Rozšíření prohlížeče Chrome',
  'ai-mate.rovo-chat-header.chrome-extension-icon-label': 'Rozšíření prohlížeče Chrome',
  'ai-mate.rovo-chat-header.close-chat-header-button-label': 'Zavřít',
  'ai-mate.rovo-chat-header.debug-button-label': 'Opravit',
  'ai-mate.rovo-chat-header.debug-icon-label': 'Opravit',
  'ai-mate.rovo-chat-header.delete-button-text': 'Odstranit',
  'ai-mate.rovo-chat-header.delete-icon-label': 'Odstranit',
  'ai-mate.rovo-chat-header.feedback-button-text': 'Zpětná vazba',
  'ai-mate.rovo-chat-header.feedback-icon-label': 'Zpětná vazba',
  'ai-mate.rovo-chat-header.floating-button-text': 'Plovoucí',
  'ai-mate.rovo-chat-header.floating-icon-label': 'Plovoucí',
  'ai-mate.rovo-chat-header.fullscreen-button-text': 'Celá obrazovka',
  'ai-mate.rovo-chat-header.fullscreen-icon-label': 'Celá obrazovka',
  'ai-mate.rovo-chat-header.get-help-button-text': 'Získat pomoc',
  'ai-mate.rovo-chat-header.get-help-icon-label': 'Získat pomoc',
  'ai-mate.rovo-chat-header.menu-button-label': 'Nabídka',
  'ai-mate.rovo-chat-header.more-menu-button-label': 'Více',
  'ai-mate.rovo-chat-header.new-agent-chat-button-label': 'Nový chat s agentem {agentName}',
  'ai-mate.rovo-chat-header.new-chat-button-label': 'Nový chat',
  'ai-mate.rovo-chat-header.rename-button-text': 'Přejmenovat',
  'ai-mate.rovo-chat-header.rename-icon-label': 'Přejmenovat',
  'ai-mate.rovo-chat-header.sidebar-button-text': 'Postranní panel',
  'ai-mate.rovo-chat-header.sidebar-icon-label': 'Postranní panel',
  'ai-mate.rovo-chat-header.switch-mode-button-label': 'Přepnout na',
  'ai-mate.rovo-chat-header.switch-mode-section-text': 'Přepnout na',
  'conversation-assistant-button.ask-rovo-label': 'Zeptejte se nástroje Rovo',
  'conversation-assistant-message-actions.require-information-tool.project-selector.header': 'Vyberte projekt',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Odeslat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Zeptejte se na to AI.',
  'highlight-actions.rovo-chat-explain-option.text': 'Vysvětlit',
  'highlight-actions.rovo-chat-explain-prompt':
    'Vysvětlete to přeformulováním a přidáním dalších podrobností, ale používejte velmi jednoduchý jazyk a krátké věty a uveďte příklady nebo definice veškeré technické terminologie používané v původní formulaci.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Najít zdroje',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Najděte v rámci znalostí organizace pouze takové zdroje, které podporují učiněná prohlášení.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Uvést příklady',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Uveďte příklady ze zdrojů organizace nebo veřejných znalostí. Pokud neexistují žádné zdroje, které byste mohli poskytnout, zkuste uvést metaforický příklad, který by mohl pomoci lépe tomu porozumět.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Poskytnout zpětnou vazbu',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Poskytněte zpětnou vazbu tím, že zkontrolujete formulaci. Poskytněte komentář k výběru slov, gramatice, interpunkci. Buďte pozitivní a energičtí, ale vždy uveďte alespoň jednu věc, kterou by šlo zlepšit nebo změnit.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Doporučení chatu',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Otevřít chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Shrnout',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Zvýrazněte klíčové body. Zaměřte se na základní informace a vylučte zbytečné podrobnosti. Poskytněte stručný přehled v jediném odstavci.',
  'highlight-actions.rovo-chat.ask-in-chat-button-text': 'Zeptat se v chatu',
  'highlight-actions.rovo-chat.ask-rovo-button-text': 'Zeptejte se nástroje Rovo',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Zeptejte se na to.',
  'horizontal-scroll-container.scroll-left': 'Posunout doleva',
  'horizontal-scroll-container.scroll-right': 'Posunout doprava',
  'rovo-chat.deep-research-spotlight.description':
    'Zapněte hluboký výzkum a zadejte výzvu. Rovo vytvoří plán, provede výzkum a vygeneruje úplnou zprávu.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Zavřít',
  'rovo-chat.deep-research-spotlight.heading': 'Představujeme hluboký výzkum v nástroji Rovo',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Přetažením přidejte kontext.',
  'rovo-chat.message-file.icon-label': 'Soubor',
  'rovo-chat.rovo-greeting.deep-research-greeting-text': 'Pojďme do hloubky',
  'rovo-chat.rovo-greeting.default-greeting-text': 'Jak mohu pomoci, {name}?',
  'rovo-chat.search-input.screen-reader-prompt':
    'Při zadání libovolného znaku do tohoto pole se aktualizují níže uvedené výsledky vyhledávání.',
};
